module.exports = __webpack_public_path__ + "static/travel-logo-0be1bf05709767471223a6def12713d3.png";